import { List } from 'immutable';

const KEY = 'freebetCredits';

function request() {
    return finish( ...arguments );
}

function error() {
    return finish( ...arguments );
}

function finish( state, { customerId, creditId } ) {
    const path = [ KEY, customerId, 'remove' ];
    const oldItems = state.getIn( path, List() );

    // Remove/add credit from/to the list
    return state.setIn( path, oldItems.includes( creditId ) ?
        oldItems.filter( id => id !== creditId ) :
        oldItems.concat( List( [ creditId ] ) )
    );
}

export { request, error, finish };
